import React, { useState, useImperativeHandle } from "react";
import { Grid } from "semantic-ui-react";
import InputField from '../../../components/commonComponents/formComponents/inputField';
import DropDown from "../../../components/commonComponents/formComponents/dropDown";
import { statusCodeValCan, statusCodeValDec, statusCodeValCor, statusCodeValExt, statusCodeValSup, nextCustomStates } from './mockConstants';

const MockFieldsNL = ({reference, transmissionType, propMRN, propShipmentId, ESCustomState}) => {
    const [mrn, setMrn] = useState(propMRN);
    const [shipmentId, setShipmentId] = useState(propShipmentId);
    const [statusCode, setStatusCode] = useState(-1);
    useImperativeHandle(reference, () => ({
        getUpdateResponseData: () => {
            return {common: {mrn, shipmentId, statusCode}
        }
        },
    }));
    return ( 
        <Grid>
            <Grid.Row>
                <Grid.Column width={6} className={`row-ur-mrn`}>
                    <InputField
                        isLabel={false}
                        id="ur-mrn"
                        className={'field-bg ur-mrn'}
                        label="MRN"
                        disabled={false}
                        value={mrn}
                        onChange={(value) => setMrn(value)}
                    />
                </Grid.Column>
                <Grid.Column width={6} className={`row-ur-mrn`}>
                    <InputField
                        isLabel={false}
                        id="ur-ducr"
                        className={'field-bg ur-mrn'}
                        label="Shipment Id"
                        disabled={true}
                        value={shipmentId}
                        onChange={(value) => setShipmentId(value)}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
                    <Grid.Column>
                        <DropDown 
                            style={{"borderColor": "#1765AE"}}
                            type="text"
                            id='StatusCode'
                            label="Status Code"
                            className="status-dropdown field-bg dropdown100 row-ur-status-code"
                            data={nextCustomStates(ESCustomState)}
                            //data={transmissionType==="CAN" ? statusCodeValCan : transmissionType==="EXT" ? statusCodeValExt : transmissionType==="DEC" ? statusCodeValDec : transmissionType=== "SUP" ? statusCodeValSup : statusCodeValCor(ESCustomState)}
                            value={statusCode === -1 ? "SELECT" : statusCode}
                            onChange={(value) => setStatusCode(value)}
                        />
                    </Grid.Column>
                </Grid.Row>
        </Grid>
     );
}
 
export default MockFieldsNL;